module.exports = __webpack_public_path__ + "img/img_14_brand_retail@3x.e954d677.png";